// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ca2b0c64cdcd5d925 {\r\n    height: 100%;\r\n}\r\n\r\n.ca2b0c64cdcd5d925 iframe {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/Modal/Help.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".container {\r\n    height: 100%;\r\n}\r\n\r\n.container iframe {\r\n    width: 100%;\r\n    height: 100%;\r\n    border: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ca2b0c64cdcd5d925"
};
export default ___CSS_LOADER_EXPORT___;
